module.exports = __webpack_public_path__ + "img/icon-warning-snø-2.781f61a1.svg";